import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=68e68276&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "@/pages/announcement/common/style/add.scss?vue&type=style&index=0&id=68e68276&lang=scss&scoped=true&external"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&lang=css&external"
import style2 from "./detail.vue?vue&type=style&index=2&id=68e68276&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e68276",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68e68276')) {
      api.createRecord('68e68276', component.options)
    } else {
      api.reload('68e68276', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=68e68276&scoped=true", function () {
      api.rerender('68e68276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/announcement/detail.vue"
export default component.exports